import { render, staticRenderFns } from "./bonus0.vue?vue&type=template&id=98e38f78&scoped=true&"
import script from "./bonus0.vue?vue&type=script&lang=js&"
export * from "./bonus0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e38f78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98e38f78')) {
      api.createRecord('98e38f78', component.options)
    } else {
      api.reload('98e38f78', component.options)
    }
    module.hot.accept("./bonus0.vue?vue&type=template&id=98e38f78&scoped=true&", function () {
      api.rerender('98e38f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/bonus0.vue"
export default component.exports